import { useState } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { FiMail } from 'react-icons/fi';
import api from '../api/client';

export default function VerificarCorreo() {
    const location = useLocation();
    const navigate = useNavigate();
    const [correo, setCorreo] = useState(location.state?.correo || '');
    const [codigo, setCodigo] = useState('');
    const [error, setError] = useState('');
    const [exito, setExito] = useState('');
    const [cargando, setCargando] = useState(false);

    const verificar = async (e) => {
        e.preventDefault();
        setError(''); setExito('');
        if (!correo || !codigo) { setError('Ingresa correo y codigo'); return; }
        setCargando(true);
        try {
            await api.post('/auth/verificar-correo', { correo, codigo });
            setExito('Correo verificado. Ya puedes iniciar sesion.');
            setTimeout(() => navigate('/login'), 1500);
        } catch (err) {
            setError(err.response?.data?.error || 'Error verificando');
        } finally {
            setCargando(false);
        }
    };

    const reenviar = async () => {
        setError(''); setExito('');
        try {
            await api.post('/auth/reenviar-codigo', { correo });
            setExito('Codigo reenviado a tu correo');
        } catch (err) {
            setError(err.response?.data?.error || 'Error reenviando');
        }
    };

    return (
        <div className="auth-wrapper">
            <div className="auth-card">
                <div className="auth-logo"><FiMail /></div>
                <h1 className="auth-title">Verifica tu correo</h1>
                <p className="auth-subtitle">Te enviamos un codigo de 6 digitos a {correo || 'tu correo'}</p>

                {error && <div className="error-msg">{error}</div>}
                {exito && <div className="exito-msg">{exito}</div>}

                <form onSubmit={verificar} autoComplete="off">
                    {!location.state?.correo && (
                        <div className="form-group">
                            <input
                                className="input"
                                type="email"
                                placeholder="Correo electronico"
                                value={correo}
                                onChange={e => setCorreo(e.target.value)}
                                autoComplete="off"
                            />
                        </div>
                    )}
                    <div className="form-group">
                        <input
                            className="input"
                            type="text"
                            placeholder="Codigo de 6 digitos"
                            value={codigo}
                            onChange={e => setCodigo(e.target.value.replace(/\D/g, ''))}
                            maxLength="6"
                            autoComplete="one-time-code"
                            inputMode="numeric"
                            style={{ textAlign: 'center', letterSpacing: '6px', fontSize: 18 }}
                        />
                    </div>
                    <button type="submit" className="btn btn-primario btn-bloque" disabled={cargando}>
                        {cargando ? 'Verificando...' : 'Verificar'}
                    </button>
                </form>

                <div className="auth-link">
                    <span style={{ cursor: 'pointer' }} onClick={reenviar}>Reenviar codigo</span>
                </div>
                <div className="auth-link">
                    <Link to="/login">Volver al login</Link>
                </div>
            </div>
        </div>
    );
}
